import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createTopUpIntent,
  syncPaymentIntentToWallet
} from '../api/accountApi';
import { getStripeBrowser } from '../stripeBrowser';
import { useAccountGetToken } from './useAccountApi';

export function useStripeTopUp() {
  const getToken = useAccountGetToken();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      amountCad,
      paymentMethodId
    }: {
      amountCad: number;
      paymentMethodId: string;
    }) => {
      const { clientSecret } = await createTopUpIntent(
        getToken,
        amountCad,
        paymentMethodId
      );
      const stripe = await getStripeBrowser();
      if (!stripe) throw new Error('Stripe is not configured');
      const result = await stripe.confirmCardPayment(clientSecret);
      if (result.error) {
        throw new Error(result.error.message ?? 'Payment failed');
      }
      const pi = result.paymentIntent;
      if (!pi?.id) {
        throw new Error('Missing payment intent');
      }
      await syncPaymentIntentToWallet(getToken, pi.id);
      return pi;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['account', 'wallet'] });
      void qc.invalidateQueries({ queryKey: ['account', 'leads'] });
      void qc.invalidateQueries({
        queryKey: ['account', 'billingRecentPayments']
      });
      window.setTimeout(() => {
        void qc.invalidateQueries({ queryKey: ['account', 'wallet'] });
      }, 1500);
    }
  });
}
